export enum UserRowActionType {
  BLOCK_USER = 'BLOCK_USER',
  UNBLOCK_USER = 'UNBLOCK_USER',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  SEND_FORGOT_PASSWORD_EMAIL = 'SEND_FORGOT_PASSWORD_EMAIL',
  CHANGE_USER = 'CHANGE_USER',
  CHANGE_USER_BY_ID = 'CHANGE_USER_BY_ID',
  ADD_TWO_FACTOR_AUTH = 'ADD_TWO_FACTOR_AUTH',
  REMOVE_TWO_FACTOR_AUTH = 'REMOVE_TWO_FACTOR_AUTH',
  SEE_PASSWORD_RECOVERY_LIST = 'SEE_PASSWORD_RECOVERY_LIST',
  CHANGE_TO_ANOTHER_CHANNEL = 'CHANGE_TO_ANOTHER_CHANNEL',
}
